export const DependentStatus = {
  CREATED: "created",
  ENROLLMENT_PENDING: "enrollment-pending",
  DELETE_PENDING: "delete-pending",
  SUSPENDED: "suspended",
  DELETED: "deleted",
};
